import Emitter from 'tiny-emitter'

const globalEmitter = new Emitter()

export default globalEmitter
